import { render, staticRenderFns } from "./step3-selectMajor.vue?vue&type=template&id=1caf214e&scoped=true"
import script from "./step3-selectMajor.vue?vue&type=script&lang=js"
export * from "./step3-selectMajor.vue?vue&type=script&lang=js"
import style0 from "./step3-selectMajor.vue?vue&type=style&index=0&id=1caf214e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caf214e",
  null
  
)

export default component.exports